import Library from '../../utility/Library';

export default class Types {

	static string (value, src) {

		return value;
	}

	static int (value, src) {

		return typeof value === 'string' ? parseInt(value, 10) : value;
	}

	static bool (value, src) {

		return (typeof value === 'string' ? (value === "true" ? true : false) : value) || false;
	}

	static statustype (value, src) {

		return value;
	}

	static event (value, src) {

		return value;
	}

	static value (value, src) {

		return value;
	}

	static data (value, src) {

		return value || [];
	}

	static property (value, src) {

		return value || [];
	}

	static card (value, src) {

		if (!(typeof value === 'string')) 
			return value;
		switch (value) {
		case 'this': return src;
		default: return src;
		}
	}

	static entity (value, src) {

		if (!(typeof value === 'string'))
			return value;
		switch (value) {
		case 'champion': return src.master.player;
		default: return src.id.type === "enemy" ? src : (src.id.type === "status" ? src.entity : src.master.player);
		}
	}

	static location (value, src) {

		if (!(typeof value === 'string'))
			return value;
		switch (value) {
		case 'this': return src.location;
		case 'hand': return src.master.hand;
		case 'deck': return src.master.deck;
		case 'supply': return src.master.supply;
		case 'discard': return src.master.discard;
		case 'exile': return src.master.exile;
		case 'stock': return src.master.stock;
		default: return null;
		}
	}

	static cardfilter (value, src) {

		if (!(typeof value === 'string')) {
			if (value === null)
				return null;
			return value;
		}
		switch (value) {
		case 'attack': return (card) => card.type === "attack";
		case 'special': return (card) => card.type === "special";
		case 'augment': return (card) => Library.hasSubtype(card.model || card, "augment");
		case 'engine': return (card) => Library.hasSubtype(card.model || card, "engine");
		case 'hex': return (card) => card.type === "hex";
		case 'fusion': return (card) => card.type === "fusion";
		case 'starter': return (card) => card.starter;
		default: return null;
		}
	}

	static entityfilter (value, src) {

		if (!(typeof value === 'string'))
			return value;
		switch (value) {
		case "champion": return (entity) => entity.id === "champion";
		case "enemy": return (entity) => entity.id !== "champion";
		case "dead": return (entity) => entity.hp <= 0;
		case "dead enemy": return (entity) => entity.id !== "champion" && entity.hp <= 0;
		case "living enemy": return (entity) => entity.id !== "champion" && entity.hp > 0;
		default: return (entity) => true;
		}
	}

	static model (value, src) {

		switch (value) {
		case 'this': return src.model;
		default: return Library.getCard(value);
		}
	}

	static modelfilter (value) {

		if (!(typeof value === 'string'))
			return value;
		switch (value) {
		case 'common': return model => model.rarity === 1;
		case 'uncommon': return model => model.rarity === 2;
		case 'rare': return model => model.rarity === 3;
		case 'attack': return model => model.type === "attack";
		case 'special': return model => model.type === "special";
		case 'augment': return model => Library.hasSubtype(model, "augment");
		case 'engine': return model => Library.hasSubtype(model, "engine");
		case 'hex': return model => model.type === "hex";
		default: return model => true;
		}
	}

	static effecttype (value, src) {

		if (!(typeof value === 'string'))
			return value;
		switch (value) {
		case 'evanescence': return target => target.type === "evanescence";
		default: return target => true;
		}
	}

	static period (value, src) {

		if (!(typeof value === 'string'))
			return value;
		switch (value) {
		case 'this turn': return 1;
		case 'all game': return 0;
		case 'this fight': return 4;
		case 'last event': return 2;
		case 'last turn': return 3;
		default: return 0;
		}
	}

	static timestamp (value, src) {

		return value;
	}
}
